import React from 'react';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import editPen from 'v2/icons/editPen.svg';

interface IEditRequestLinkProps {
  searchId: number;
  isSearchInEditingAndSubmittable: boolean;
}

export const EditRequestLink = ({
  searchId,
  isSearchInEditingAndSubmittable,
}: IEditRequestLinkProps) => {
  return (
    <Link
      to={`/edit/${searchId}`}
      replace
      className={classnames(
        'mr-2',
        'btn-secondary-dark',
        'btn btn-secondary',
        'editBtn'
      )}
    >
      <img src={editPen} alt={'editPenIcon'} className={'pr-2'}></img>
      {isSearchInEditingAndSubmittable ? 'Edit' : 'Edit Request'}
    </Link>
  );
};
